// import { useState } from "react";
// import FormField from "./FormField";

// const CouponForm = ({ initialData, onSave, onClose }) => {
//     const formatDateTime = (dateString) => {
//         if (!dateString) return '';
//         const date = new Date(dateString);
//         // The time is adjusted for the IST timezone (UTC+5:30).
//         const d = new Date(date.getTime() + (5.5 * 60 * 60 * 1000));
//         const yyyy = d.getUTCFullYear();
//         const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
//         const dd = String(d.getUTCDate()).padStart(2, '0');
//         const hh = String(d.getUTCHours()).padStart(2, '0');
//         const min = String(d.getUTCMinutes()).padStart(2, '0');
//         return `${yyyy}-${mm}-${dd}T${hh}:${min}`;
//     };

//     const [formData, setFormData] = useState({
//         coupon_code: initialData?.coupon_code || '',
//         discount_type: initialData?.discount_type || 'FIXED',
//         discount_value: initialData?.discount_value || '',
//         min_order_value: initialData?.min_order_value || '',
//         max_discount: initialData?.max_discount || '',
//         usage_limit: initialData?.usage_limit || '',
//         start_date: initialData?.start_date ? formatDateTime(initialData.start_date) : formatDateTime(new Date()),
//         expiration_date: initialData?.expiration_date ? formatDateTime(initialData.expiration_date) : '',
//         is_active: initialData?.is_active ?? true,
//     });

//     const handleChange = (e) => {
//         const { id, value, type, checked } = e.target;
//         setFormData(prev => ({
//             ...prev,
//             [id]: type === 'checkbox' ? checked : value
//         }));
//     };

//     const handleSubmit = (e) => {
//         e.preventDefault();
//         onSave(formData);
//     };

//     return (
//         <form onSubmit={handleSubmit}>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                 <FormField
//                     label="Coupon Code"
//                     id="coupon_code"
//                     type="text"
//                     value={formData.coupon_code}
//                     onChange={handleChange}
//                     required
//                     maxLength={30}
//                 />
//                 <FormField
//                     label="Discount Type"
//                     id="discount_type"
//                     type="select"
//                     value={formData.discount_type}
//                     onChange={handleChange}
//                     required
//                 >
//                     <option value="FIXED">Fixed Amount</option>
//                     <option value="PERCENTAGE">Percentage</option>
//                 </FormField>
//                 <FormField
//                     label="Discount Value"
//                     id="discount_value"
//                     type="number"
//                     value={formData.discount_value}
//                     onChange={handleChange}
//                     required
//                     inputMode="decimal"
//                 />
//                 <FormField
//                     label="Minimum Order Value"
//                     id="min_order_value"
//                     type="number"
//                     value={formData.min_order_value}
//                     onChange={handleChange}
//                     required
//                     inputMode="decimal"
//                 />
//                 <FormField
//                     label="Maximum Discount"
//                     id="max_discount"
//                     type="number"
//                     value={formData.max_discount}
//                     onChange={handleChange}
//                     inputMode="decimal"
//                 />
//                 <FormField
//                     label="Usage Limit"
//                     id="usage_limit"
//                     type="number"
//                     value={formData.usage_limit}
//                     onChange={handleChange}
//                     inputMode="numeric"
//                 />
//                 <FormField
//                     label="Start Date"
//                     id="start_date"
//                     type="datetime-local"
//                     value={formData.start_date}
//                     onChange={handleChange}
//                     required
//                 />
//                 <FormField
//                     label="Expiration Date"
//                     id="expiration_date"
//                     type="datetime-local"
//                     value={formData.expiration_date}
//                     onChange={handleChange}
//                     required
//                 />
//             </div>
//             <div className="flex items-center mt-4">
//                 <input
//                     id="is_active"
//                     name="is_active"
//                     type="checkbox"
//                     checked={formData.is_active}
//                     onChange={handleChange}
//                     className="h-4 w-4 text-indigo-600 rounded border-gray-300 focus:ring-indigo-500"
//                 />
//                 <label htmlFor="is_active" className="ml-2 block text-sm text-gray-900">
//                     Is Active
//                 </label>
//             </div>
//             <div className="mt-6 flex justify-end space-x-2">
//                 <button
//                     type="button"
//                     onClick={onClose}
//                     className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors"
//                 >
//                     Cancel
//                 </button>
//                 <button
//                     type="submit"
//                     className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors"
//                 >
//                     Save
//                 </button>
//             </div>
//         </form>
//     );
// };

// export default CouponForm;


import { useState } from "react";
import FormField from "./FormField";

const CouponForm = ({ initialData, onSave, onClose }) => {
    const formatDateTime = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const d = new Date(date.getTime() + (5.5 * 60 * 60 * 1000));
        const yyyy = d.getUTCFullYear();
        const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
        const dd = String(d.getUTCDate()).padStart(2, '0');
        const hh = String(d.getUTCHours()).padStart(2, '0');
        const min = String(d.getUTCMinutes()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}T${hh}:${min}`;
    };

    const [formData, setFormData] = useState({
        coupon_code: initialData?.coupon_code || '',
        channel: initialData?.channel || 'All', // Added channel state
        discount_type: initialData?.discount_type || 'FIXED',
        discount_value: initialData?.discount_value || '',
        min_order_value: initialData?.min_order_value || '',
        max_discount: initialData?.max_discount || '',
        usage_limit: initialData?.usage_limit || '',
        coupon_type: initialData?.coupon_type || 'General',
        start_date: initialData?.start_date ? formatDateTime(initialData.start_date) : formatDateTime(new Date()),
        expiration_date: initialData?.expiration_date ? formatDateTime(initialData.expiration_date) : '',
        is_active: initialData?.is_active ?? true,
    });

    // Logical check: If channel is Retail, fields are not mandatory
    const isRetail = formData.channel === 'Retail';

    const handleChange = (e) => {
        const { id, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [id]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(formData);
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <FormField
                    label="Coupon Code"
                    id="coupon_code"
                    type="text"
                    value={formData.coupon_code}
                    onChange={handleChange}
                    required
                    maxLength={30}
                />

                {/* CouponType Dropdown */}
                <FormField
                    label="Coupon Type"
                    id="coupon_type"
                    type="select"
                    value={formData.coupon_type}
                    onChange={handleChange}
                    required
                >
                    <option value="General">General</option>
                    <option value="Promo">Promo</option>
                    <option value="User">User</option>
                </FormField>
                {/* New Channel Dropdown */}
                <FormField
                    label="Channel"
                    id="channel"
                    type="select"
                    value={formData.channel}
                    onChange={handleChange}
                    required
                >
                    <option value="All">All</option>
                    <option value="Retail">Retail</option>
                    <option value="Web">Web</option>
                </FormField>

                <FormField
                    label="Discount Type"
                    id="discount_type"
                    type="select"
                    value={formData.discount_type}
                    onChange={handleChange}
                    required
                >
                    <option value="FIXED">Fixed Amount</option>
                    <option value="PERCENTAGE">Percentage</option>
                </FormField>

                <FormField
                    label={`Discount Value ${isRetail ? '(Optional)' : ''}`}
                    id="discount_value"
                    type="number"
                    value={formData.discount_value}
                    onChange={handleChange}
                    required={!isRetail} // Not mandatory if Retail
                    inputMode="decimal"
                />

                <FormField
                    label={`Minimum Order Value ${isRetail ? '(Optional)' : ''}`}
                    id="min_order_value"
                    type="number"
                    value={formData.min_order_value}
                    onChange={handleChange}
                    required={!isRetail} // Not mandatory if Retail
                    inputMode="decimal"
                />

                <FormField
                    label="Maximum Discount"
                    id="max_discount"
                    type="number"
                    value={formData.max_discount}
                    onChange={handleChange}
                    inputMode="decimal"
                />

                <FormField
                    label="Usage Limit"
                    id="usage_limit"
                    type="number"
                    value={formData.usage_limit}
                    onChange={handleChange}
                    inputMode="numeric"
                />

                <FormField
                    label="Start Date"
                    id="start_date"
                    type="datetime-local"
                    value={formData.start_date}
                    onChange={handleChange}
                    required
                />

                <FormField
                    label="Expiration Date"
                    id="expiration_date"
                    type="datetime-local"
                    value={formData.expiration_date}
                    onChange={handleChange}
                    required
                />
            </div>

            <div className="flex items-center mt-4">
                <input
                    id="is_active"
                    name="is_active"
                    type="checkbox"
                    checked={formData.is_active}
                    onChange={handleChange}
                    className="h-4 w-4 text-indigo-600 rounded border-gray-300 focus:ring-indigo-500"
                />
                <label htmlFor="is_active" className="ml-2 block text-sm text-gray-900">
                    Is Active
                </label>
            </div>

            <div className="mt-6 flex justify-end space-x-2">
                <button
                    type="button"
                    onClick={onClose}
                    className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors"
                >
                    Cancel
                </button>
                <button
                    type="submit"
                    className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors"
                >
                    Save
                </button>
            </div>
        </form>
    );
};

export default CouponForm;